module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "student-summary"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', {
    class: _vm.headerNameClass,
    on: {
      "click": function($event) {
        _vm.sort(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.tokens['name']))]), _vm._l((_vm.statistics), function(stat, index) {
    return _c('th', {
      key: index,
      class: _vm.statNameClass(stat, index),
      attrs: {
        "title": stat.title || ''
      },
      on: {
        "click": function($event) {
          _vm.sort(index)
        }
      }
    }, [_vm._v(_vm._s(stat.name))])
  })], 2)]), _c('tbody', _vm._l((_vm.students), function(student) {
    return _c('tr', {
      key: student.ref.id
    }, [_c('td', [_vm._v(_vm._s(student.ref.name))]), _vm._l((student.statistics), function(stat, index) {
      return _c('td', {
        key: index
      }, [(index === 1) ? _c('span', [_vm._v(_vm._s(((Math.floor(stat / 60).toFixed(0)) + ":" + (_vm.secondsToString( stat % 60 )))))]) : _c('span', [(_vm.statistics[index].hasProgress) ? _c('span', {
        class: {
          'progressLink': true
        },
        on: {
          "click": function($event) {
            _vm.showProgress(student, index)
          }
        }
      }, [_vm._v(_vm._s(stat))]) : _c('span', [_vm._v(_vm._s(stat))])])])
    })], 2)
  }))])]), (_vm.isShowingProgress) ? _c('modal-container', {
    attrs: {
      "title": _vm.progressChartData.title
    },
    on: {
      "close": _vm.closeChart
    }
  }, [_c('progress-chart', {
    staticClass: "chart",
    attrs: {
      "data": _vm.progressChartData
    }
  })], 1) : _vm._e(), _c('control-panel', {
    attrs: {
      "title": _vm.title,
      "options": _vm.options
    },
    on: {
      "show-options": _vm.showOptions,
      "close": _vm.close
    }
  }), _c('options', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOptionsDisplayed),
      expression: "isOptionsDisplayed"
    }],
    attrs: {
      "values": _vm.options
    },
    on: {
      "close": _vm.closeOptions,
      "apply": _vm.applyOptions
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47a95014"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vis/StudentsSummary.vue
// module id = 418
// module chunks = 0